export default __webpack_public_path__ + "media/projects/purple1-1712bf30.svg";